import { withInstall } from '@ll-plus/utils'

import Space from './src/space.vue'

export const LlSpace = withInstall(Space)
export default LlSpace
export * from './src/space'

declare module 'vue' {
  export interface GlobalComponents {
    LlSpace: typeof Space
  }
}
